import { render, staticRenderFns } from "./Intermediador.vue?vue&type=template&id=715b2f96"
import script from "./Intermediador.vue?vue&type=script&lang=js"
export * from "./Intermediador.vue?vue&type=script&lang=js"
import style0 from "./Intermediador.vue?vue&type=style&index=0&id=715b2f96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports